import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

function sessionId() {
  let s = localStorage.getItem("rama_sess");
  if (!s) {
    s = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("rama_sess", s);
  }
  return s;
}

function device() {
  const w = window.innerWidth;
  if (w < 640) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

export default function AnalyticsTracker() {
  const loc = useLocation();
  useEffect(() => {
    // Skip tracking for admin routes
    if (loc.pathname.startsWith("/admin")) return;
    const payload = {
      session_id: sessionId(),
      path: loc.pathname,
      referrer: document.referrer || "",
      device: device(),
      ua: navigator.userAgent.slice(0, 200),
    };
    api.post("/analytics/track", payload).catch(() => {});
  }, [loc.pathname]);
  return null;
}
